import { useLocation } from "react-router";
import { useMemo } from "react";
import { publicRoutes, protectedRoutes } from "@/routing";

export const useIsProtectedRoute = () => {
  const location = useLocation();
  return useMemo(() => !publicRoutes.some((route) => route.path === location.pathname), [location.pathname]);
};

export const useIsDataRoute = () => {
  const location = useLocation();
  return useMemo(
    () => [protectedRoutes[1], protectedRoutes[2], protectedRoutes[6]].some((route) => route.path === location.pathname),
    [location.pathname],
  );
};

export const useIsSearchRoute = () => {
  const location = useLocation();
  return useMemo(
    () =>
      [protectedRoutes[0], protectedRoutes[1], protectedRoutes[2], protectedRoutes[4], protectedRoutes[6]].some(
        (route) => route.path === location.pathname,
      ),
    [location.pathname],
  );
};

export const useIsFeedbackRoute = () => {
  const location = useLocation();
  return useMemo(
    () => [protectedRoutes[0], protectedRoutes[1], protectedRoutes[2]].some((route) => route.path === location.pathname),
    [location.pathname],
  );
};

export const useIsPublicRoute = () => {
  const location = useLocation();
  return useMemo(() => publicRoutes.some((route) => route.path === location.pathname), [location.pathname]);
};

export const useIsLoginRoute = () => {
  const location = useLocation();
  return useMemo(() => publicRoutes[0].path === location.pathname, [location.pathname]);
};

export const useReturnUrl = () => {
  const location = useLocation();
  return encodeURIComponent(`${location.pathname.slice(1)}${location.search}`);
};

export const useLocationPotentialRouteState = () => {
  const location = useLocation();
  return useMemo(
    () =>
      protectedRoutes[1].path === location.pathname
        ? "load_rates"
        : protectedRoutes[0].path === location.pathname || protectedRoutes[2].path === location.pathname
          ? "market_potential"
          : protectedRoutes[4].path === location.pathname
            ? "company_analytics"
            : protectedRoutes[6].path === location.pathname
              ? "loadboard"
              : undefined,
    [location.pathname],
  );
};

export const useIsAnalyticRoute = () => {
  const location = useLocation();
  return useMemo(() => protectedRoutes[4].path === location.pathname, [location.pathname]);
};

export const useIsLoadSearchRoute = () => {
  const location = useLocation();
  return useMemo(() => protectedRoutes[6].path === location.pathname, [location.pathname]);
};

export const useIsCircleRoute = () => {
  const location = useLocation();
  return useMemo(() => [publicRoutes[0], protectedRoutes[3]].some((route) => route.path === location.pathname), [location.pathname]);
};
